export function formatUnixTimestamp(unixTimestamp) {
  const date = new Date(unixTimestamp * 1000) // Convert seconds to milliseconds

  // Format options for US users
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  }

  return new Intl.DateTimeFormat("en-US", options).format(date)
}

export function compareJson(json1, json2) {
  const differences = []

  function findDifferences(obj1, obj2, field = "") {
    if (Array.isArray(obj1) && Array.isArray(obj2)) {
      // Compare arrays
      const maxLength = Math.max(obj1.length, obj2.length)
      for (let i = 0; i < maxLength; i++) {
        findDifferences(obj1[i], obj2[i], `${field}[${i}]`)
      }
    } else if (
      typeof obj1 === "object" &&
      typeof obj2 === "object" &&
      obj1 !== null &&
      obj2 !== null
    ) {
      // Compare objects, check for new properties in obj2
      const keys = new Set([
        ...Object.keys(obj1 || {}),
        ...Object.keys(obj2 || {}),
      ])

      keys.forEach((key) => {
        const fullPath = field ? `${field}.${key}` : key

        if (!(key in obj1)) {
          // New property in obj2, store value correctly if it's an object with data
          const newValue =
            obj2[key]?.data !== undefined ? obj2[key].data : obj2[key]
          if (newValue !== "") {
            const fullPathD =
              fullPath.endsWith(".data") || fullPath === "organization_type"
                ? fullPath
                : `${fullPath}.data` // append .data if missing

            differences.push({
              field: fullPathD,
              preVal: "",
              newVal:
                typeof newValue === "object"
                  ? JSON.stringify(newValue)
                  : newValue,
            })
          }
        } else {
          findDifferences(obj1[key], obj2[key], fullPath)
        }
      })
    } else if (typeof obj2 === "object" && obj2 !== null) {
      // Handle nested objects with "data" fields
      Object.keys(obj2).forEach((key) => {
        if (obj2[key] && typeof obj2[key] === "object" && "data" in obj2[key]) {
          const preValue = obj1 && obj1[key] ? obj1[key].data || "" : ""
          const newValue = obj2[key].data

          if (!(preValue === "" && newValue === "")) {
            differences.push({
              field: `${field}.${key}.data`,
              preVal:
                preValue !== undefined
                  ? typeof preValue === "object"
                    ? JSON.stringify(preValue)
                    : preValue
                  : "",
              newVal:
                newValue !== undefined
                  ? typeof newValue === "object"
                    ? JSON.stringify(newValue)
                    : newValue
                  : "",
            })
          }
        }
      })
    } else if (obj1 !== obj2) {
      // Add to differences if values differ and are not both empty strings
      if (!(obj1 === "" && obj2 === "")) {
        differences.push({
          field: field || "root",
          preVal:
            obj1 !== undefined
              ? typeof obj1 === "object"
                ? JSON.stringify(obj1)
                : obj1
              : "",
          newVal:
            obj2 !== undefined
              ? typeof obj2 === "object"
                ? JSON.stringify(obj2)
                : obj2
              : "",
        })
      }
    }
  }

  findDifferences(json1, json2)

  return differences
}
